import { SelectOption } from "../parts/inputs/InputSelect";
import { translator } from "./symbols";

const getCountries = async (): Promise<void> => {

    fetch('https://restcountries.com/v3.1/all')
    .then(res => res.json())
    .then(res => {

        let countries: SelectOption[] = []

        res.forEach((countrie:any) => {
            countries.push({
                value: countrie.cca2, 
                name: `[:en]${countrie.translations.cym.common}[:][:es]${countrie.translations.spa.common}[:]`,
                flag: countrie.flag as string,
            })
        })
        // console.log(countries)
    })
    .catch((err) => console.log('err', err))
}

const fixedCountries = ['ES','GB','JP','US','IT','FR','DE','IT']

export const CountriesOptions: SelectOption[] = [
    {
        "value": "ES",
        "name": "[:en]Spain[:][:es]España[:]",
        "flag": "🇪🇸"
    },
    {
        "value": "GB",
        "name": "[:en]United Kingdom[:][:es]Reino Unido[:]",
        "flag": "🇬🇧"
    },
    {
        "value": "JP",
        "name": "[:en]Japan[:][:es]Japón[:]",
        "flag": "🇯🇵"
    },
    {
        "value": "US",
        "name": "[:en]United States[:][:es]Estados Unidos[:]",
        "flag": "🇺🇸"
    },
    {
        "value": "IT",
        "name": "[:en]Italy[:][:es]Italia[:]",
        "flag": "🇮🇹"
    },
    {
        "value": "FR",
        "name": "[:en]France[:][:es]Francia[:]",
        "flag": "🇫🇷"
    },
    {
        "value": "DE",
        "name": "[:en]Germany[:][:es]Alemania[:]",
        "flag": "🇩🇪"
    },
    {
        "value": "GS",
        "name": "[:en]South Georgia[:][:es]Islas Georgias del Sur y Sandwich del Sur[:]",
        "flag": "🇬🇸"
    },
    {
        "value": "GD",
        "name": "[:en]Grenada[:][:es]Grenada[:]",
        "flag": "🇬🇩"
    },
    {
        "value": "CH",
        "name": "[:en]Switzerland[:][:es]Suiza[:]",
        "flag": "🇨🇭"
    },
    {
        "value": "SL",
        "name": "[:en]Sierra Leone[:][:es]Sierra Leone[:]",
        "flag": "🇸🇱"
    },
    {
        "value": "HU",
        "name": "[:en]Hungary[:][:es]Hungría[:]",
        "flag": "🇭🇺"
    },
    {
        "value": "TW",
        "name": "[:en]Taiwan[:][:es]Taiwán[:]",
        "flag": "🇹🇼"
    },
    {
        "value": "WF",
        "name": "[:en]Wallis and Futuna[:][:es]Wallis y Futuna[:]",
        "flag": "🇼🇫"
    },
    {
        "value": "BB",
        "name": "[:en]Barbados[:][:es]Barbados[:]",
        "flag": "🇧🇧"
    },
    {
        "value": "PN",
        "name": "[:en]Pitcairn Islands[:][:es]Islas Pitcairn[:]",
        "flag": "🇵🇳"
    },
    {
        "value": "CI",
        "name": "[:en]Ivory Coast[:][:es]Costa de Marfil[:]",
        "flag": "🇨🇮"
    },
    {
        "value": "TN",
        "name": "[:en]Tunisia[:][:es]Túnez[:]",
        "flag": "🇹🇳"
    },
    {
        "value": "BJ",
        "name": "[:en]Benin[:][:es]Benín[:]",
        "flag": "🇧🇯"
    },
    {
        "value": "ID",
        "name": "[:en]Indonesia[:][:es]Indonesia[:]",
        "flag": "🇮🇩"
    },
    {
        "value": "CV",
        "name": "[:en]Penrhyn Verde[:][:es]Cabo Verde[:]",
        "flag": "🇨🇻"
    },
    {
        "value": "KN",
        "name": "[:en]Saint Kitts and Nevis[:][:es]San Cristóbal y Nieves[:]",
        "flag": "🇰🇳"
    },
    {
        "value": "LA",
        "name": "[:en]Laos[:][:es]Laos[:]",
        "flag": "🇱🇦"
    },
    {
        "value": "BQ",
        "name": "[:en]Caribbean Netherlands[:][:es]Caribe Neerlandés[:]",
        "flag": "🇧🇶"
    },
    {
        "value": "UG",
        "name": "[:en]Uganda[:][:es]Uganda[:]",
        "flag": "🇺🇬"
    },
    {
        "value": "AD",
        "name": "[:en]Andorra[:][:es]Andorra[:]",
        "flag": "🇦🇩"
    },
    {
        "value": "BI",
        "name": "[:en]Bwrwndi[:][:es]Burundi[:]",
        "flag": "🇧🇮"
    },
    {
        "value": "ZA",
        "name": "[:en]South Africa[:][:es]Sudáfrica[:]",
        "flag": "🇿🇦"
    },
    {
        "value": "LY",
        "name": "[:en]Libya[:][:es]Libia[:]",
        "flag": "🇱🇾"
    },
    {
        "value": "MX",
        "name": "[:en]Mexico[:][:es]México[:]",
        "flag": "🇲🇽"
    },
    {
        "value": "GA",
        "name": "[:en]Gabon[:][:es]Gabón[:]",
        "flag": "🇬🇦"
    },
    {
        "value": "MP",
        "name": "[:en]Northern Mariana Islands[:][:es]Islas Marianas del Norte[:]",
        "flag": "🇲🇵"
    },
    {
        "value": "MK",
        "name": "[:en]North Macedonia[:][:es]Macedonia del Norte[:]",
        "flag": "🇲🇰"
    },
    {
        "value": "CN",
        "name": "[:en]Tsieina[:][:es]China[:]",
        "flag": "🇨🇳"
    },
    {
        "value": "YE",
        "name": "[:en]Yemen[:][:es]Yemen[:]",
        "flag": "🇾🇪"
    },
    {
        "value": "BL",
        "name": "[:en]Saint Barthélemy[:][:es]San Bartolomé[:]",
        "flag": "🇧🇱"
    },
    {
        "value": "GG",
        "name": "[:en]Guernsey[:][:es]Guernsey[:]",
        "flag": "🇬🇬"
    },
    {
        "value": "SB",
        "name": "[:en]Solomon Islands[:][:es]Islas Salomón[:]",
        "flag": "🇸🇧"
    },
    {
        "value": "SJ",
        "name": "[:en]Svalbard and Jan Mayen[:][:es]Islas Svalbard y Jan Mayen[:]",
        "flag": "🇸🇯"
    },
    {
        "value": "FO",
        "name": "[:en]Faroe Islands[:][:es]Islas Faroe[:]",
        "flag": "🇫🇴"
    },
    {
        "value": "UZ",
        "name": "[:en]Uzbekistan[:][:es]Uzbekistán[:]",
        "flag": "🇺🇿"
    },
    {
        "value": "EG",
        "name": "[:en]Yr Aifft[:][:es]Egipto[:]",
        "flag": "🇪🇬"
    },
    {
        "value": "SN",
        "name": "[:en]Senegal[:][:es]Senegal[:]",
        "flag": "🇸🇳"
    },
    {
        "value": "LK",
        "name": "[:en]Sri Lanka[:][:es]Sri Lanka[:]",
        "flag": "🇱🇰"
    },
    {
        "value": "PS",
        "name": "[:en]Palestine[:][:es]Palestina[:]",
        "flag": "🇵🇸"
    },
    {
        "value": "BD",
        "name": "[:en]Bangladesh[:][:es]Bangladesh[:]",
        "flag": "🇧🇩"
    },
    {
        "value": "PE",
        "name": "[:en]Peru[:][:es]Perú[:]",
        "flag": "🇵🇪"
    },
    {
        "value": "SG",
        "name": "[:en]Singapore[:][:es]Singapur[:]",
        "flag": "🇸🇬"
    },
    {
        "value": "TR",
        "name": "[:en]Turkey[:][:es]Turquía[:]",
        "flag": "🇹🇷"
    },
    {
        "value": "AF",
        "name": "[:en]Afghanistan[:][:es]Afganistán[:]",
        "flag": "🇦🇫"
    },
    {
        "value": "AW",
        "name": "[:en]Aruba[:][:es]Aruba[:]",
        "flag": "🇦🇼"
    },
    {
        "value": "CK",
        "name": "[:en]Ynysoedd Cook[:][:es]Islas Cook[:]",
        "flag": "🇨🇰"
    },
    {
        "value": "ZM",
        "name": "[:en]Zambia[:][:es]Zambia[:]",
        "flag": "🇿🇲"
    },
    {
        "value": "FI",
        "name": "[:en]Finland[:][:es]Finlandia[:]",
        "flag": "🇫🇮"
    },
    {
        "value": "NE",
        "name": "[:en]Niger[:][:es]Níger[:]",
        "flag": "🇳🇪"
    },
    {
        "value": "CX",
        "name": "[:en]Ynys y Nadolig[:][:es]Isla de Navidad[:]",
        "flag": "🇨🇽"
    },
    {
        "value": "TK",
        "name": "[:en]Tokelau[:][:es]Islas Tokelau[:]",
        "flag": "🇹🇰"
    },
    {
        "value": "GW",
        "name": "[:en]Guinea-Bissau[:][:es]Guinea-Bisáu[:]",
        "flag": "🇬🇼"
    },
    {
        "value": "AZ",
        "name": "[:en]Aserbaijan[:][:es]Azerbaiyán[:]",
        "flag": "🇦🇿"
    },
    {
        "value": "RE",
        "name": "[:en]Réunion[:][:es]Reunión[:]",
        "flag": "🇷🇪"
    },
    {
        "value": "DJ",
        "name": "[:en]Jibwti[:][:es]Djibouti[:]",
        "flag": "🇩🇯"
    },
    {
        "value": "KP",
        "name": "[:en]North Korea[:][:es]Corea del Norte[:]",
        "flag": "🇰🇵"
    },
    {
        "value": "MU",
        "name": "[:en]Mauritius[:][:es]Mauricio[:]",
        "flag": "🇲🇺"
    },
    {
        "value": "MS",
        "name": "[:en]Montserrat[:][:es]Montserrat[:]",
        "flag": "🇲🇸"
    },
    {
        "value": "VI",
        "name": "[:en]United States Virgin Islands[:][:es]Islas Vírgenes de los Estados Unidos[:]",
        "flag": "🇻🇮"
    },
    {
        "value": "CO",
        "name": "[:en]Colombia[:][:es]Colombia[:]",
        "flag": "🇨🇴"
    },
    {
        "value": "GR",
        "name": "[:en]Greece[:][:es]Grecia[:]",
        "flag": "🇬🇷"
    },
    {
        "value": "HR",
        "name": "[:en]Croatia[:][:es]Croacia[:]",
        "flag": "🇭🇷"
    },
    {
        "value": "MA",
        "name": "[:en]Morocco[:][:es]Marruecos[:]",
        "flag": "🇲🇦"
    },
    {
        "value": "DZ",
        "name": "[:en]Algeria[:][:es]Argelia[:]",
        "flag": "🇩🇿"
    },
    {
        "value": "AQ",
        "name": "[:en]Yr Antarctig[:][:es]Antártida[:]",
        "flag": "🇦🇶"
    },
    {
        "value": "NL",
        "name": "[:en]Netherlands[:][:es]Países Bajos[:]",
        "flag": "🇳🇱"
    },
    {
        "value": "SD",
        "name": "[:en]Sudan[:][:es]Sudán[:]",
        "flag": "🇸🇩"
    },
    {
        "value": "FJ",
        "name": "[:en]Fiji[:][:es]Fiyi[:]",
        "flag": "🇫🇯"
    },
    {
        "value": "LI",
        "name": "[:en]Liechtenstein[:][:es]Liechtenstein[:]",
        "flag": "🇱🇮"
    },
    {
        "value": "NP",
        "name": "[:en]Nepal[:][:es]Nepal[:]",
        "flag": "🇳🇵"
    },
    {
        "value": "PR",
        "name": "[:en]Puerto Rico[:][:es]Puerto Rico[:]",
        "flag": "🇵🇷"
    },
    {
        "value": "GE",
        "name": "[:en]Georgia[:][:es]Georgia[:]",
        "flag": "🇬🇪"
    },
    {
        "value": "PK",
        "name": "[:en]Pakistan[:][:es]Pakistán[:]",
        "flag": "🇵🇰"
    },
    {
        "value": "MC",
        "name": "[:en]Monaco[:][:es]Mónaco[:]",
        "flag": "🇲🇨"
    },
    {
        "value": "BW",
        "name": "[:en]Botswana[:][:es]Botswana[:]",
        "flag": "🇧🇼"
    },
    {
        "value": "LB",
        "name": "[:en]Lebanon[:][:es]Líbano[:]",
        "flag": "🇱🇧"
    },
    {
        "value": "PG",
        "name": "[:en]Papua New Guinea[:][:es]Papúa Nueva Guinea[:]",
        "flag": "🇵🇬"
    },
    {
        "value": "YT",
        "name": "[:en]Mayotte[:][:es]Mayotte[:]",
        "flag": "🇾🇹"
    },
    {
        "value": "DO",
        "name": "[:en]Gweriniaeth Dominica[:][:es]República Dominicana[:]",
        "flag": "🇩🇴"
    },
    {
        "value": "NF",
        "name": "[:en]Norfolk Island[:][:es]Isla de Norfolk[:]",
        "flag": "🇳🇫"
    },
    {
        "value": "BV",
        "name": "[:en]Bouvet Island[:][:es]Isla Bouvet[:]",
        "flag": "🇧🇻"
    },
    {
        "value": "QA",
        "name": "[:en]Qatar[:][:es]Catar[:]",
        "flag": "🇶🇦"
    },
    {
        "value": "MG",
        "name": "[:en]Madagascar[:][:es]Madagascar[:]",
        "flag": "🇲🇬"
    },
    {
        "value": "IN",
        "name": "[:en]India[:][:es]India[:]",
        "flag": "🇮🇳"
    },
    {
        "value": "SY",
        "name": "[:en]Syria[:][:es]Siria[:]",
        "flag": "🇸🇾"
    },
    {
        "value": "ME",
        "name": "[:en]Montenegro[:][:es]Montenegro[:]",
        "flag": "🇲🇪"
    },
    {
        "value": "SZ",
        "name": "[:en]Eswatini[:][:es]Suazilandia[:]",
        "flag": "🇸🇿"
    },
    {
        "value": "PY",
        "name": "[:en]Paraguay[:][:es]Paraguay[:]",
        "flag": "🇵🇾"
    },
    {
        "value": "SV",
        "name": "[:en]El Salfador[:][:es]El Salvador[:]",
        "flag": "🇸🇻"
    },
    {
        "value": "UA",
        "name": "[:en]Ukraine[:][:es]Ucrania[:]",
        "flag": "🇺🇦"
    },
    {
        "value": "IM",
        "name": "[:en]Isle of Man[:][:es]Isla de Man[:]",
        "flag": "🇮🇲"
    },
    {
        "value": "NA",
        "name": "[:en]Namibia[:][:es]Namibia[:]",
        "flag": "🇳🇦"
    },
    {
        "value": "AE",
        "name": "[:en]United Arab Emirates[:][:es]Emiratos Árabes Unidos[:]",
        "flag": "🇦🇪"
    },
    {
        "value": "BG",
        "name": "[:en]Bwlgaria[:][:es]Bulgaria[:]",
        "flag": "🇧🇬"
    },
    {
        "value": "GL",
        "name": "[:en]Greenland[:][:es]Groenlandia[:]",
        "flag": "🇬🇱"
    },
    {
        "value": "KH",
        "name": "[:en]Cambodia[:][:es]Camboya[:]",
        "flag": "🇰🇭"
    },
    {
        "value": "IQ",
        "name": "[:en]Iraq[:][:es]Irak[:]",
        "flag": "🇮🇶"
    },
    {
        "value": "TF",
        "name": "[:en]French Southern and Antarctic Lands[:][:es]Tierras Australes y Antárticas Francesas[:]",
        "flag": "🇹🇫"
    },
    {
        "value": "SE",
        "name": "[:en]Sweden[:][:es]Suecia[:]",
        "flag": "🇸🇪"
    },
    {
        "value": "CU",
        "name": "[:en]Ciwba[:][:es]Cuba[:]",
        "flag": "🇨🇺"
    },
    {
        "value": "KG",
        "name": "[:en]Kyrgyzstan[:][:es]Kirguizistán[:]",
        "flag": "🇰🇬"
    },
    {
        "value": "RU",
        "name": "[:en]Russia[:][:es]Rusia[:]",
        "flag": "🇷🇺"
    },
    {
        "value": "MY",
        "name": "[:en]Malaysia[:][:es]Malasia[:]",
        "flag": "🇲🇾"
    },
    {
        "value": "ST",
        "name": "[:en]São Tomé and Príncipe[:][:es]Santo Tomé y Príncipe[:]",
        "flag": "🇸🇹"
    },
    {
        "value": "CY",
        "name": "[:en]Cyprus[:][:es]Chipre[:]",
        "flag": "🇨🇾"
    },
    {
        "value": "CA",
        "name": "[:en]Canada[:][:es]Canadá[:]",
        "flag": "🇨🇦"
    },
    {
        "value": "MW",
        "name": "[:en]Malawi[:][:es]Malawi[:]",
        "flag": "🇲🇼"
    },
    {
        "value": "SA",
        "name": "[:en]Saudi Arabia[:][:es]Arabia Saudí[:]",
        "flag": "🇸🇦"
    },
    {
        "value": "BA",
        "name": "[:en]Bosnia a Hercegovina[:][:es]Bosnia y Herzegovina[:]",
        "flag": "🇧🇦"
    },
    {
        "value": "ET",
        "name": "[:en]Ethiopia[:][:es]Etiopía[:]",
        "flag": "🇪🇹"
    },
    {
        "value": "SI",
        "name": "[:en]Slovenia[:][:es]Eslovenia[:]",
        "flag": "🇸🇮"
    },
    {
        "value": "OM",
        "name": "[:en]Oman[:][:es]Omán[:]",
        "flag": "🇴🇲"
    },
    {
        "value": "PM",
        "name": "[:en]Saint Pierre and Miquelon[:][:es]San Pedro y Miquelón[:]",
        "flag": "🇵🇲"
    },
    {
        "value": "MO",
        "name": "[:en]Macau[:][:es]Macao[:]",
        "flag": "🇲🇴"
    },
    {
        "value": "SM",
        "name": "[:en]San Marino[:][:es]San Marino[:]",
        "flag": "🇸🇲"
    },
    {
        "value": "LS",
        "name": "[:en]Lesotho[:][:es]Lesotho[:]",
        "flag": "🇱🇸"
    },
    {
        "value": "MH",
        "name": "[:en]Marshall Islands[:][:es]Islas Marshall[:]",
        "flag": "🇲🇭"
    },
    {
        "value": "SX",
        "name": "[:en]Sint Maarten[:][:es]Sint Maarten[:]",
        "flag": "🇸🇽"
    },
    {
        "value": "IS",
        "name": "[:en]Iceland[:][:es]Islandia[:]",
        "flag": "🇮🇸"
    },
    {
        "value": "LU",
        "name": "[:en]Luxembourg[:][:es]Luxemburgo[:]",
        "flag": "🇱🇺"
    },
    {
        "value": "AR",
        "name": "[:en]Ariannin[:][:es]Argentina[:]",
        "flag": "🇦🇷"
    },
    {
        "value": "TC",
        "name": "[:en]Turks and Caicos Islands[:][:es]Islas Turks y Caicos[:]",
        "flag": "🇹🇨"
    },
    {
        "value": "NR",
        "name": "[:en]Nauru[:][:es]Nauru[:]",
        "flag": "🇳🇷"
    },
    {
        "value": "CC",
        "name": "[:en]Ynysoedd Cocos[:][:es]Islas Cocos o Islas Keeling[:]",
        "flag": "🇨🇨"
    },
    {
        "value": "EH",
        "name": "[:en]Western Sahara[:][:es]Sahara Occidental[:]",
        "flag": "🇪🇭"
    },
    {
        "value": "DM",
        "name": "[:en]Dominica[:][:es]Dominica[:]",
        "flag": "🇩🇲"
    },
    {
        "value": "CR",
        "name": "[:en]Costa Rica[:][:es]Costa Rica[:]",
        "flag": "🇨🇷"
    },
    {
        "value": "AU",
        "name": "[:en]Awstralia[:][:es]Australia[:]",
        "flag": "🇦🇺"
    },
    {
        "value": "TH",
        "name": "[:en]Thailand[:][:es]Tailandia[:]",
        "flag": "🇹🇭"
    },
    {
        "value": "HT",
        "name": "[:en]Haiti[:][:es]Haití[:]",
        "flag": "🇭🇹"
    },
    {
        "value": "TV",
        "name": "[:en]Tuvalu[:][:es]Tuvalu[:]",
        "flag": "🇹🇻"
    },
    {
        "value": "HN",
        "name": "[:en]Honduras[:][:es]Honduras[:]",
        "flag": "🇭🇳"
    },
    {
        "value": "GQ",
        "name": "[:en]Gini Gyhydeddol[:][:es]Guinea Ecuatorial[:]",
        "flag": "🇬🇶"
    },
    {
        "value": "LC",
        "name": "[:en]Saint Lucia[:][:es]Santa Lucía[:]",
        "flag": "🇱🇨"
    },
    {
        "value": "PF",
        "name": "[:en]French Polynesia[:][:es]Polinesia Francesa[:]",
        "flag": "🇵🇫"
    },
    {
        "value": "BY",
        "name": "[:en]Belarws[:][:es]Bielorrusia[:]",
        "flag": "🇧🇾"
    },
    {
        "value": "LV",
        "name": "[:en]Latvia[:][:es]Letonia[:]",
        "flag": "🇱🇻"
    },
    {
        "value": "PW",
        "name": "[:en]Palau[:][:es]Palau[:]",
        "flag": "🇵🇼"
    },
    {
        "value": "GP",
        "name": "[:en]Guadeloupe[:][:es]Guadalupe[:]",
        "flag": "🇬🇵"
    },
    {
        "value": "PH",
        "name": "[:en]Philippines[:][:es]Filipinas[:]",
        "flag": "🇵🇭"
    },
    {
        "value": "GI",
        "name": "[:en]Gibraltar[:][:es]Gibraltar[:]",
        "flag": "🇬🇮"
    },
    {
        "value": "DK",
        "name": "[:en]Denmarc[:][:es]Dinamarca[:]",
        "flag": "🇩🇰"
    },
    {
        "value": "CM",
        "name": "[:en]Camerŵn[:][:es]Camerún[:]",
        "flag": "🇨🇲"
    },
    {
        "value": "GN",
        "name": "[:en]Guinea[:][:es]Guinea[:]",
        "flag": "🇬🇳"
    },
    {
        "value": "BH",
        "name": "[:en]Bahrain[:][:es]Bahrein[:]",
        "flag": "🇧🇭"
    },
    {
        "value": "SR",
        "name": "[:en]Suriname[:][:es]Surinam[:]",
        "flag": "🇸🇷"
    },
    {
        "value": "CD",
        "name": "[:en]Gweriniaeth Ddemocrataidd Congo[:][:es]Congo (Rep. Dem.)[:]",
        "flag": "🇨🇩"
    },
    {
        "value": "SO",
        "name": "[:en]Somalia[:][:es]Somalia[:]",
        "flag": "🇸🇴"
    },
    {
        "value": "CZ",
        "name": "[:en]Y Weriniaeth Tsiec[:][:es]Chequia[:]",
        "flag": "🇨🇿"
    },
    {
        "value": "NC",
        "name": "[:en]New Caledonia[:][:es]Nueva Caledonia[:]",
        "flag": "🇳🇨"
    },
    {
        "value": "VU",
        "name": "[:en]Vanuatu[:][:es]Vanuatu[:]",
        "flag": "🇻🇺"
    },
    {
        "value": "SH",
        "name": "[:en]Saint Helena, Ascension and Tristan da Cunha[:][:es]Santa Elena, Ascensión y Tristán de Acuña[:]",
        "flag": "🇸🇭"
    },
    {
        "value": "TG",
        "name": "[:en]Togo[:][:es]Togo[:]",
        "flag": "🇹🇬"
    },
    {
        "value": "VG",
        "name": "[:en]British Virgin Islands[:][:es]Islas Vírgenes del Reino Unido[:]",
        "flag": "🇻🇬"
    },
    {
        "value": "KE",
        "name": "[:en]Kenya[:][:es]Kenia[:]",
        "flag": "🇰🇪"
    },
    {
        "value": "NU",
        "name": "[:en]Niue[:][:es]Niue[:]",
        "flag": "🇳🇺"
    },
    {
        "value": "HM",
        "name": "[:en]Heard Island and McDonald Islands[:][:es]Islas Heard y McDonald[:]",
        "flag": "🇭🇲"
    },
    {
        "value": "RW",
        "name": "[:en]Rwanda[:][:es]Ruanda[:]",
        "flag": "🇷🇼"
    },
    {
        "value": "EE",
        "name": "[:en]Estonia[:][:es]Estonia[:]",
        "flag": "🇪🇪"
    },
    {
        "value": "RO",
        "name": "[:en]Romania[:][:es]Rumania[:]",
        "flag": "🇷🇴"
    },
    {
        "value": "TT",
        "name": "[:en]Trinidad and Tobago[:][:es]Trinidad y Tobago[:]",
        "flag": "🇹🇹"
    },
    {
        "value": "GY",
        "name": "[:en]Guyana[:][:es]Guyana[:]",
        "flag": "🇬🇾"
    },
    {
        "value": "TL",
        "name": "[:en]Timor-Leste[:][:es]Timor Oriental[:]",
        "flag": "🇹🇱"
    },
    {
        "value": "VN",
        "name": "[:en]Vietnam[:][:es]Vietnam[:]",
        "flag": "🇻🇳"
    },
    {
        "value": "UY",
        "name": "[:en]Uruguay[:][:es]Uruguay[:]",
        "flag": "🇺🇾"
    },
    {
        "value": "VA",
        "name": "[:en]Vatican City[:][:es]Ciudad del Vaticano[:]",
        "flag": "🇻🇦"
    },
    {
        "value": "HK",
        "name": "[:en]Hong Kong[:][:es]Hong Kong[:]",
        "flag": "🇭🇰"
    },
    {
        "value": "AT",
        "name": "[:en]Awstria[:][:es]Austria[:]",
        "flag": "🇦🇹"
    },
    {
        "value": "AG",
        "name": "[:en]Antigwa a Barbiwda[:][:es]Antigua y Barbuda[:]",
        "flag": "🇦🇬"
    },
    {
        "value": "TM",
        "name": "[:en]Turkmenistan[:][:es]Turkmenistán[:]",
        "flag": "🇹🇲"
    },
    {
        "value": "MZ",
        "name": "[:en]Mozambique[:][:es]Mozambique[:]",
        "flag": "🇲🇿"
    },
    {
        "value": "PA",
        "name": "[:en]Panama[:][:es]Panamá[:]",
        "flag": "🇵🇦"
    },
    {
        "value": "FM",
        "name": "[:en]Micronesia[:][:es]Micronesia[:]",
        "flag": "🇫🇲"
    },
    {
        "value": "IE",
        "name": "[:en]Ireland[:][:es]Irlanda[:]",
        "flag": "🇮🇪"
    },
    {
        "value": "CW",
        "name": "[:en]Curaçao[:][:es]Curazao[:]",
        "flag": "🇨🇼"
    },
    {
        "value": "GF",
        "name": "[:en]French Guiana[:][:es]Guayana Francesa[:]",
        "flag": "🇬🇫"
    },
    {
        "value": "NO",
        "name": "[:en]Norway[:][:es]Noruega[:]",
        "flag": "🇳🇴"
    },
    {
        "value": "AX",
        "name": "[:en]Åland Islands[:][:es]Alandia[:]",
        "flag": "🇦🇽"
    },
    {
        "value": "CF",
        "name": "[:en]Gweriniaeth Canolbarth Affrica[:][:es]República Centroafricana[:]",
        "flag": "🇨🇫"
    },
    {
        "value": "BF",
        "name": "[:en]Bwrcina Ffaso[:][:es]Burkina Faso[:]",
        "flag": "🇧🇫"
    },
    {
        "value": "ER",
        "name": "[:en]Eritrea[:][:es]Eritrea[:]",
        "flag": "🇪🇷"
    },
    {
        "value": "TZ",
        "name": "[:en]Tanzania[:][:es]Tanzania[:]",
        "flag": "🇹🇿"
    },
    {
        "value": "KR",
        "name": "[:en]South Korea[:][:es]Corea del Sur[:]",
        "flag": "🇰🇷"
    },
    {
        "value": "JO",
        "name": "[:en]Jordan[:][:es]Jordania[:]",
        "flag": "🇯🇴"
    },
    {
        "value": "MR",
        "name": "[:en]Mauritania[:][:es]Mauritania[:]",
        "flag": "🇲🇷"
    },
    {
        "value": "LT",
        "name": "[:en]Lithuania[:][:es]Lituania[:]",
        "flag": "🇱🇹"
    },
    {
        "value": "UM",
        "name": "[:en]United States Minor Outlying Islands[:][:es]Islas Ultramarinas Menores de Estados Unidos[:]",
        "flag": "🇺🇲"
    },
    {
        "value": "SK",
        "name": "[:en]Slovakia[:][:es]República Eslovaca[:]",
        "flag": "🇸🇰"
    },
    {
        "value": "AO",
        "name": "[:en]Angola[:][:es]Angola[:]",
        "flag": "🇦🇴"
    },
    {
        "value": "KZ",
        "name": "[:en]Kazakhstan[:][:es]Kazajistán[:]",
        "flag": "🇰🇿"
    },
    {
        "value": "MD",
        "name": "[:en]Moldova[:][:es]Moldavia[:]",
        "flag": "🇲🇩"
    },
    {
        "value": "ML",
        "name": "[:en]Mali[:][:es]Mali[:]",
        "flag": "🇲🇱"
    },
    {
        "value": "FK",
        "name": "[:en]Falkland Islands[:][:es]Islas Malvinas[:]",
        "flag": "🇫🇰"
    },
    {
        "value": "AM",
        "name": "[:en]Armenia[:][:es]Armenia[:]",
        "flag": "🇦🇲"
    },
    {
        "value": "WS",
        "name": "[:en]Samoa[:][:es]Samoa[:]",
        "flag": "🇼🇸"
    },
    {
        "value": "JE",
        "name": "[:en]Jersey[:][:es]Jersey[:]",
        "flag": "🇯🇪"
    },
    {
        "value": "BO",
        "name": "[:en]Bolifia[:][:es]Bolivia[:]",
        "flag": "🇧🇴"
    },
    {
        "value": "CL",
        "name": "[:en]Chile[:][:es]Chile[:]",
        "flag": "🇨🇱"
    },
    {
        "value": "VC",
        "name": "[:en]Saint Vincent and the Grenadines[:][:es]San Vicente y Granadinas[:]",
        "flag": "🇻🇨"
    },
    {
        "value": "BM",
        "name": "[:en]Bermiwda[:][:es]Bermudas[:]",
        "flag": "🇧🇲"
    },
    {
        "value": "SC",
        "name": "[:en]Seychelles[:][:es]Seychelles[:]",
        "flag": "🇸🇨"
    },
    {
        "value": "IO",
        "name": "[:en]Tiriogaeth Brydeinig Cefnfor India[:][:es]Territorio Británico del Océano Índico[:]",
        "flag": "🇮🇴"
    },
    {
        "value": "GT",
        "name": "[:en]Guatemala[:][:es]Guatemala[:]",
        "flag": "🇬🇹"
    },
    {
        "value": "EC",
        "name": "[:en]Ecwador[:][:es]Ecuador[:]",
        "flag": "🇪🇨"
    },
    {
        "value": "MQ",
        "name": "[:en]Martinique[:][:es]Martinica[:]",
        "flag": "🇲🇶"
    },
    {
        "value": "TJ",
        "name": "[:en]Tajikistan[:][:es]Tayikistán[:]",
        "flag": "🇹🇯"
    },
    {
        "value": "MT",
        "name": "[:en]Malta[:][:es]Malta[:]",
        "flag": "🇲🇹"
    },
    {
        "value": "GM",
        "name": "[:en]Gambia[:][:es]Gambia[:]",
        "flag": "🇬🇲"
    },
    {
        "value": "NG",
        "name": "[:en]Nigeria[:][:es]Nigeria[:]",
        "flag": "🇳🇬"
    },
    {
        "value": "BS",
        "name": "[:en]Bahamas[:][:es]Bahamas[:]",
        "flag": "🇧🇸"
    },
    {
        "value": "XK",
        "name": "[:en]Kosovo[:][:es]Kosovo[:]",
        "flag": "🇽🇰"
    },
    {
        "value": "KW",
        "name": "[:en]Kuwait[:][:es]Kuwait[:]",
        "flag": "🇰🇼"
    },
    {
        "value": "MV",
        "name": "[:en]Maldives[:][:es]Maldivas[:]",
        "flag": "🇲🇻"
    },
    {
        "value": "SS",
        "name": "[:en]South Sudan[:][:es]Sudán del Sur[:]",
        "flag": "🇸🇸"
    },
    {
        "value": "IR",
        "name": "[:en]Iran[:][:es]Iran[:]",
        "flag": "🇮🇷"
    },
    {
        "value": "AL",
        "name": "[:en]Albania[:][:es]Albania[:]",
        "flag": "🇦🇱"
    },
    {
        "value": "BR",
        "name": "[:en]Brasil[:][:es]Brasil[:]",
        "flag": "🇧🇷"
    },
    {
        "value": "RS",
        "name": "[:en]Serbia[:][:es]Serbia[:]",
        "flag": "🇷🇸"
    },
    {
        "value": "BZ",
        "name": "[:en]Belîs[:][:es]Belice[:]",
        "flag": "🇧🇿"
    },
    {
        "value": "MM",
        "name": "[:en]Myanmar[:][:es]Myanmar[:]",
        "flag": "🇲🇲"
    },
    {
        "value": "BT",
        "name": "[:en]Bhwtan[:][:es]Bután[:]",
        "flag": "🇧🇹"
    },
    {
        "value": "VE",
        "name": "[:en]Venezuela[:][:es]Venezuela[:]",
        "flag": "🇻🇪"
    },
    {
        "value": "LR",
        "name": "[:en]Liberia[:][:es]Liberia[:]",
        "flag": "🇱🇷"
    },
    {
        "value": "JM",
        "name": "[:en]Jamaica[:][:es]Jamaica[:]",
        "flag": "🇯🇲"
    },
    {
        "value": "PL",
        "name": "[:en]Poland[:][:es]Polonia[:]",
        "flag": "🇵🇱"
    },
    {
        "value": "KY",
        "name": "[:en]Ynysoedd Cayman[:][:es]Islas Caimán[:]",
        "flag": "🇰🇾"
    },
    {
        "value": "BN",
        "name": "[:en]Brunei[:][:es]Brunei[:]",
        "flag": "🇧🇳"
    },
    {
        "value": "KM",
        "name": "[:en]Y Comoros[:][:es]Comoras[:]",
        "flag": "🇰🇲"
    },
    {
        "value": "GU",
        "name": "[:en]Guam[:][:es]Guam[:]",
        "flag": "🇬🇺"
    },
    {
        "value": "TO",
        "name": "[:en]Tonga[:][:es]Tonga[:]",
        "flag": "🇹🇴"
    },
    {
        "value": "KI",
        "name": "[:en]Kiribati[:][:es]Kiribati[:]",
        "flag": "🇰🇮"
    },
    {
        "value": "GH",
        "name": "[:en]Ghana[:][:es]Ghana[:]",
        "flag": "🇬🇭"
    },
    {
        "value": "TD",
        "name": "[:en]Tsiad[:][:es]Chad[:]",
        "flag": "🇹🇩"
    },
    {
        "value": "ZW",
        "name": "[:en]Zimbabwe[:][:es]Zimbabue[:]",
        "flag": "🇿🇼"
    },
    {
        "value": "MF",
        "name": "[:en]Saint Martin[:][:es]Saint Martin[:]",
        "flag": "🇲🇫"
    },
    {
        "value": "MN",
        "name": "[:en]Mongolia[:][:es]Mongolia[:]",
        "flag": "🇲🇳"
    },
    {
        "value": "PT",
        "name": "[:en]Portugal[:][:es]Portugal[:]",
        "flag": "🇵🇹"
    },
    {
        "value": "AS",
        "name": "[:en]American Samoa[:][:es]Samoa Americana[:]",
        "flag": "🇦🇸"
    },
    {
        "value": "CG",
        "name": "[:en]Gweriniaeth y Congo[:][:es]Congo[:]",
        "flag": "🇨🇬"
    },
    {
        "value": "BE",
        "name": "[:en]Gwlad Belg[:][:es]Bélgica[:]",
        "flag": "🇧🇪"
    },
    {
        "value": "IL",
        "name": "[:en]Israel[:][:es]Israel[:]",
        "flag": "🇮🇱"
    },
    {
        "value": "NZ",
        "name": "[:en]New Zealand[:][:es]Nueva Zelanda[:]",
        "flag": "🇳🇿"
    },
    {
        "value": "NI",
        "name": "[:en]Nicaragua[:][:es]Nicaragua[:]",
        "flag": "🇳🇮"
    },
    {
        "value": "AI",
        "name": "[:en]Anguilla[:][:es]Anguilla[:]",
        "flag": "🇦🇮"
    }
]
.map(({value, name, flag}) => ({value, flag, name: translator.extractTranslationFromString(name)}))
.sort((a, b) => {
    const a_is_fixed = fixedCountries.includes(a.value)
    const b_is_fixed = fixedCountries.includes(b.value)
    if (a_is_fixed && b_is_fixed) return 0
    if (a_is_fixed && !b_is_fixed) return -1
    if (!a_is_fixed && b_is_fixed) return 1
    return a.name.localeCompare(b.name)
})